(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('PersonService', PersonService)

    /** @ngInject */
    function PersonService(HttpService) {
        const PersonService = {
            getAllByTicketCategory: getAllByTicketCategory
        }

        return PersonService;

        function getAllByTicketCategory(ticketCategoryId) {
            return HttpService.get(`/people/ticket-category/${ticketCategoryId}`);
        }
    }
}());